/* eslint-disable @typescript-eslint/naming-convention */
export enum ErrorCodes {
	WorkspaceSchemaGeneratorService = 'WorkspaceSchemaGeneratorService',
	CentralDatabaseDataImporterHandler = 'CentralDatabaseDataImporterHandler',
	ConfigDatabaseDataImporterHandler = 'ConfigDatabaseDataImporterHandler',
	ConfigDatabaseRefTableHandler = 'ConfigDatabaseRefTableHandler',
	ConfigSchemaGeneratorHandler = 'ConfigSchemaGeneratorHandler',
	WorkspaceDataImportHandler = 'WorkspaceDataImportHandler',
	WorkspaceDataImportInsertDatabase = 'WorkspaceDataImportInsertDatabase',
	ApiConnectionInsert = 'ApiConnectionInsert',
	ApiConnectionDelete = 'ApiConnectionDelete',
	ApiConnectionGetConnections = 'ApiConnectionGetConnections',
	ApiConnectionIdRemove = 'ApiConnectionIdRemove',
	ApiConnectionUpdate = 'ApiConnectionUpdate',
	ApiConnectionUpdateOptions = 'ApiConnectionUpdateOptions',
	ApiConnectionUpdateAliasPath = 'ApiConnectionUpdateAliasPath',
	ApiConnectionDetails = 'ApiConnectionDetails',
	UpdateApiConnectionSelectedOptions = 'UpdateApiConnectionSelectedOptions',
	WorkspaceSchemaGeneratorHandler = 'WorkspaceSchemaGeneratorHandler',
	FileSanitizerHandler = 'FileSanitizerHandler',
	FileValidatorHandlerNoRegistrationToken = 'FileValidatorHandlerNoRegistrationToken',
	FileValidatorHandlerInvalidRegistrationToken = 'FileValidatorHandlerInvalidRegistrationToken',
	ValidateRegistrationToken = 'ValidateRegistrationToken',
	FileValidatorHandlerNoAccess = 'FileValidatorHandlerNoAccess',
	FileValidatorHandlerFusionUserNoAccess = 'FileValidatorHandlerFusionUserNoAccess',
	FileValidatorHandlerNoProjects = 'FileValidatorHandlerNoProjects',
	FileValidatorHandlerNoEntities = 'FileValidatorHandlerNoEntities',
	FileValidatorHandlerNoCombinedPrimaryKey = 'FileValidatorHandlerNoCombinedPrimaryKey',
	FileValidatorHandlerNoDataTables = 'FileValidatorHandlerNoDataTables',
	FileValidatorHandlerNoDataColumns = 'FileValidatorHandlerNoDataColumns',
	FileValidatorHandlerMaxColumnWidth = 'FileValidatorHandlerMaxColumnWidth',
	FileValidatorHandlerMaxTablesCount = 'FileValidatorHandlerMaxTablesCount',
	EditWorkFileNameHandler = 'EditWorkFileNameHandler',
	WorkfileDoesNotExist = 'WorkfileDoesNotExist',
	ImportPageError = 'ImportPageError',
	AsyncValidationOrchestrator = 'AsyncValidationOrchestrator',
	NoPlatformDetected = 'NoPlatformDetected',
	WebExportError = 'WebExportError',
	AndroidExportError = 'AndroidExportError',
	IOSExportError = 'IosExportError',
	NoStandardTable = 'NoStandardTableDefined',
	NoSamplesTable = 'NoSamplesTableDefined',
	ArchiveWorkfileOnExport = 'ArchiveWorkfileOnExport',
	RestoreDatabaseError = 'RestoreDatabaseError',
	InitializeDatabase = 'InitializeDatabase',
	DeleteRecordFailed = 'DeleteRecordFailed',
	DeleteChainError = 'DeleteChainError',
	DeleteGapError = 'DeleteGapError',
	DeleteStartAtZeroError = 'DeleteStartAtZeroError',
	OriginalHasQcError = 'OriginalHasQcError',
	IntervalRelatedError = 'IntervalRelatedError',
	DatePickerHandler = 'DatePickerHandler',
	NullInputParam = 'NullInputParam',
	DeleteExternalCreatedError = 'DeleteExternalCreatedError',
	DeleteWorkfileError = 'DeleteWorkfileError',
	PendingDeleteWorkfileError = 'PendingDeleteWorkfileError',
	DotNetCalculateFormulaError = 'DotNetCalculatFormulaError',
	RegistrationDecodeJWTTokenError = 'RegistrationDecodeJWTTokenError',
	RegistrationConfigHeaderError = 'RegistrationConfigHeaderError',
	RegistrationDeviceIdError = 'RegistrationDeviceIdError',
	RegistrationEncryptCredentialsError = 'RegistrationEncryptCredentialsError',
	ApiKeyDecryptionError = 'ApiKeyDecryptionError',
	RegistrationFormIsNotValidError = 'RegistrationFormIsNotValidError',
	RegistrationSaveCredentialsError = 'RegistrationSaveCredentialsError',
	AuthenticationFailed = 'AuthenticationFailed',
	SyncFailed = 'SyncFailed',
	TransferInFailed = 'TransferInFailed',
	NoConnectionAssociated = 'NoConnectionAssociated',
	CheckoutNoRecordToUpdate = 'CheckoutNoRecordToUpdate',
	CheckoutError = 'CheckoutError',
	CopyInError = 'CopyInError',
	CheckInError = 'CheckInError',
	CheckOutError = 'CheckOutError',
	CheckOutJsonParseError = 'CheckOutJsonParseError',
	NoActiveWorkfile = 'NoActiveWorkfile',
	TransferOutStructureError = 'TransferOutStructureError',
	TransferOutDataStructureError = 'TransferOutDataStructureError',
	GalleryPhotoUploadError = 'GalleryPhotoUploadError',
	ReportPreviewError = 'ReportPreviewError',
	ExcelFileExporterServiceError = 'ExcelFileExporterServiceError',
	CSVFileExporterServiceError = 'CSVFileExporterServiceError',
	MissingPrimaryKey = 'MissingPrimaryKey',
	MissingTableName = 'MissingTableName'
}
